import { FC, PropsWithChildren } from 'react';

import styles from './PageLayout.css';

export const PageLayout: FC<PropsWithChildren> = ({ children }) => (
  <div className={styles['page-layout']}>{children}</div>
);
